import $ from 'jquery';
import 'lazysizes';
import tippy from 'tippy.js';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

export default () => {
  function init() {
    initHeader()

  }

  function initHeader() {
    
// const LAZY_CSS_DISTANCE = 800

// const loadedStylesheets = new Set()

// let lazyCssObserver = null


// /**
//  * Check if stylesheet is already on the page.
//  */
// const stylesheetExists = (url) => {
//     if (!url) {
//         return false
//     }

//     const absoluteUrl = new URL(
//         url,
//         window.location.href
//     ).href

//     return Array.from(
//         document.querySelectorAll('link[rel="stylesheet"]')
//     ).some((link) => {
//         return link.href === absoluteUrl
//     })
// }


// /**
//  * Load stylesheet.
//  */
// const loadStylesheet = (element) => {
//     if (!element) {
//         return
//     }

//     const url = element.dataset.lazySectionCss

//     if (!url) {
//         return
//     }

//     const absoluteUrl = new URL(
//         url,
//         window.location.href
//     ).href

//     /**
//      * Already loaded.
//      */
//     if (
//         loadedStylesheets.has(absoluteUrl) ||
//         stylesheetExists(absoluteUrl)
//     ) {
//         element.remove()
//         return
//     }

//     loadedStylesheets.add(absoluteUrl)

//     const link = document.createElement('link')

//     link.rel = 'stylesheet'
//     link.href = absoluteUrl

//     link.onload = () => {
//         element.remove()
//     }

//     link.onerror = () => {
//         loadedStylesheets.delete(absoluteUrl)

//         console.error(
//             '[Lazy CSS] Failed to load:',
//             absoluteUrl
//         )
//     }

//     document.head.appendChild(link)
// }


// /**
//  * Check if marker is already above,
//  * inside, or close to viewport.
//  *
//  * This is important when:
//  *
//  * - refreshing halfway down the page
//  * - browser restores scroll position
//  * - using back/forward navigation
//  */
// const shouldLoadImmediately = (element) => {
//     const rect = element.getBoundingClientRect()

//     return rect.top <= (
//         window.innerHeight + LAZY_CSS_DISTANCE
//     )
// }


// /**
//  * Create observer once.
//  */
// const createLazyCssObserver = () => {
//     if (lazyCssObserver) {
//         return lazyCssObserver
//     }

//     lazyCssObserver = new IntersectionObserver(
//         (entries) => {
//             entries.forEach((entry) => {
//                 if (!entry.isIntersecting) {
//                     return
//                 }

//                 loadStylesheet(entry.target)

//                 lazyCssObserver.unobserve(
//                     entry.target
//                 )
//             })
//         },
//         {
//             root: null,
//             rootMargin: `${LAZY_CSS_DISTANCE}px 0px`,
//             threshold: 0
//         }
//     )

//     return lazyCssObserver
// }


// /**
//  * Initialize lazy CSS.
//  */
// const initLazySectionCSS = () => {
//     const elements = document.querySelectorAll(
//         '[data-lazy-section-css]:not([data-lazy-css-initialized])'
//     )

//     if (!elements.length) {
//         return
//     }

//     /**
//      * Fallback.
//      */
//     if (!('IntersectionObserver' in window)) {
//         elements.forEach((element) => {
//             loadStylesheet(element)
//         })

//         return
//     }

//     const observer = createLazyCssObserver()

//     elements.forEach((element) => {
//         element.setAttribute(
//             'data-lazy-css-initialized',
//             'true'
//         )

//         /**
//          * IMPORTANT:
//          *
//          * If page was refreshed while scrolled down,
//          * immediately load every CSS file whose marker
//          * is already above or near the viewport.
//          */
//         if (shouldLoadImmediately(element)) {
//             loadStylesheet(element)
//             return
//         }

//         /**
//          * Otherwise lazy-load normally.
//          */
//         observer.observe(element)
//     })
// }


// /**
//  * Initial DOM load.
//  */
// if (document.readyState === 'loading') {
//     document.addEventListener(
//         'DOMContentLoaded',
//         initLazySectionCSS
//     )
// } else {
//     initLazySectionCSS()
// }


// /**
//  * Run again after full page load.
//  *
//  * Important because browsers can restore
//  * scroll position after DOMContentLoaded.
//  */
// window.addEventListener('load', () => {
//     requestAnimationFrame(() => {
//         initLazySectionCSS()
//     })
// })


// /**
//  * Handles browser back/forward cache.
//  */
// window.addEventListener('pageshow', () => {
//     requestAnimationFrame(() => {
//         initLazySectionCSS()
//     })
// })


// /**
//  * Shopify Theme Editor.
//  */
// document.addEventListener(
//     'shopify:section:load',
//     initLazySectionCSS
// )

    tippy('[data-tippy-content]');

    // tippy('.information-icon', {
    //   content: 'My tooltip!',
    // });

    //hide/show header on scroll
    let scrollDirectionDown = true

    window.addEventListener('scroll', function() {
        /**
         * Hide/Show header on scroll
         * If user scrolls down header will be hidden or if user scrolls up header will be visible
         */
        scrollDirectionDown = this.oldScroll <= this.scrollY
        this.oldScroll = this.scrollY

        if( window.scrollY > 100 ) {
          hideHeader()
            // document.querySelector('header').classList.add('scrolled')
        } else {
          showHeader()
            // document.querySelector('header').classList.remove('scrolled')
        }

        if ( scrollDirectionDown ) {
            // Scrolling down
            if(
                window.scrollY > 100
                &&
                !$('header').hasClass('nav-is-active')
            )
                hideHeader()
        } else {
            showHeader()
        }
        /**
         * Hide/Show header on scroll END
         */
    })

    function showHeader() {
      document.querySelector('header').parentNode.style.top = '0px'

      if(document.querySelector('.section-product-header')){
        document.querySelector('.section-product-header').parentNode.style.top = document.querySelector('header').offsetHeight + 'px'
      }
    }

    function hideHeader() {
        document.querySelector('header').parentNode.style.top = - document.querySelector('header').offsetHeight + 'px'

        if(document.querySelector('.section-product-header')){
          document.querySelector('.section-product-header').parentNode.style.top = 0
        }
        
    }

    function subscribe(eventName, callback) {
      let cb = (event) => callback(event)
    
      document.addEventListener(eventName, cb)
    
      return function unsubscribe() {
        document.removeEventListener(eventName, cb)
      }
    }
    
    function publish(eventName, options) {
      document.dispatchEvent(new CustomEvent(eventName, options))
    }
    //hide/show header on scroll END
    
    const EVENTS = {
      cartBeforeChange: 'cart:before-change',
      cartChange: 'cart:change',
      cartError: 'cart:error',
      lineItemChange: 'line-item:change',
      variantChange: 'variant:change'
    }

    //VARIANT PICKER JS OLD
    // class BlockVariantPicker extends HTMLElement {
    //   //old
    //   connectedCallback() {
    //     this.productInfo = new Map()

    //     this.addEventListener('change', this.handleVariantChange.bind(this))
    //     this.addEventListener('touchstart', this.handleElementEvent.bind(this))
    //     this.addEventListener('mousedown', this.handleElementEvent.bind(this))
    //   }

    //   handleElementEvent(event) {
        
    //     // TODO: evaluate creating a custom dropdown component to listen to touchstart and mousedown events
    //     const target = event.target.previousElementSibling

    //     if (target?.tagName !== 'INPUT') {
    //       return
    //     }

    //     this.updateOptions(target)
    //     this.updateMasterId()
    //     this.currentVariant && this.getProductInfo()
    //   }

    //   //old
    //   async handleVariantChange() {
        
    //     this.updateOptions()
    //     this.updateMasterId()
    //     this.updateVariantStatuses()

    //     if (this.currentVariant) {
    //       this.updateURL()
    //       const html = await this.getProductInfo()

    //       publish(EVENTS.variantChange, {
    //         detail: {
    //           html,
    //           sectionId: this.sectionId,
    //           variant: this.currentVariant
    //         }
    //       })
    //     } else {
    //       publish(EVENTS.variantChange, {
    //         detail: {
    //           html: null,
    //           sectionId: this.sectionId,
    //           variant: null
    //         }
    //       })
    //     }
    //   }

    //   updateOptions(target) {
    //     console.log('radim poso update')
    //     this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
    //       if (element.tagName === 'SELECT') {
    //         return element.value
    //       }

    //       if (element.tagName === 'FIELDSET') {
    //         return Array.from(element.querySelectorAll('input')).find(
    //           (radio) => (target && radio === target) ?? radio.checked
    //         )?.value
    //       }
    //     })
    //   }

    //   updateMasterId() {
    //     this.currentVariant = this.getVariantData().find(
    //       (variant) => !variant.options.map((option, index) => this.options[index] === option).includes(false)
    //     )
    //   }

    //   getVariantData() {
    //     this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
    //     return this.variantData
    //   }

    //   //old
    //   updateVariantStatuses() {
    //     const selectedOptionOneVariants = this.variantData.filter(
    //       (variant) => this.querySelector(':checked').value === variant.option1
    //     )
    //     const inputWrappers = [...this.querySelectorAll('fieldset')]
    //     inputWrappers.forEach((option, index) => {
    //       if (index === 0) return

    //       const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
    //       const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value
    //       const availableOptionInputsValue = selectedOptionOneVariants
    //         .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
    //         .map((variantOption) => variantOption[`option${index + 1}`])

    //       this.setInputAvailability(optionInputs, availableOptionInputsValue)
    //     })
    //   }

    //   //old
    //   setInputAvailability(elementList, availableValuesList) {
    //     elementList.forEach((element) => {
    //       const value = element.getAttribute('value')
    //       const availableElement = availableValuesList.includes(value)

    //       if (element.tagName === 'INPUT') {
    //         element.toggleAttribute('data-disabled', !availableElement)
    //       }
    //     })
    //   }

    //   updateURL() {
    //     //if statement added so that QUICK BUY is not changing url on other pages and on QUICK BUY on product page
    //     if($('body').hasClass('product') && !$(this).parent().hasClass('quick-buy-drawer-info')){

    //       if (!this.currentVariant || !this.updateUrl) {
    //         return
    //       }

    //       window.history.replaceState({}, '', `${this.url}?variant=${this.currentVariant.id}`)
    //     } else{
    //       $('quick-buy-drawer .top-section .btn').attr('href', `${this.url}?variant=${this.currentVariant.id}`)
    //     }

    //   }

    //   getProductInfo() {
    //     const requestedVariantId = this.currentVariant.id

    //     if (this.productInfo.has(requestedVariantId)) {
    //       return this.productInfo.get(requestedVariantId)
    //     }

    //     this.productInfo.set(
    //       requestedVariantId,
    //       fetch(`${this.url}?variant=${requestedVariantId}&section_id=${this.sectionId}`)
    //         .then((response) => response.text())
    //         .then((responseText) => new DOMParser().parseFromString(responseText, 'text/html'))
    //     )

    //     return this.productInfo.get(requestedVariantId)
    //   }

    //   get sectionId() {
    //     return this.getAttribute('section-id')
    //   }

    //   get updateUrl() {
    //     return this.getAttribute('update-url') === 'true'
    //   }

    //   get url() {
    //     return this.getAttribute('url')
    //   }
    // }
    // customElements.define('block-variant-picker', BlockVariantPicker)

    //VARIANT PICKER JS NEW
    class BlockVariantPicker extends HTMLElement {
      connectedCallback() {
        this.productInfo = new Map()
        this._isFixing = false

        this.addEventListener('change', this.handleVariantChange.bind(this))
        this.addEventListener('touchstart', this.handleElementEvent.bind(this))
        this.addEventListener('mousedown', this.handleElementEvent.bind(this))

        // initial run
        this.updateOptions()
        this.updateMasterId()
        this.updateVariantStatuses()

        // If initial selection is not available, snap to first available
        this.pickFirstAvailableIfNeeded()
        this.updateOptions()
        this.updateMasterId()
        this.updateVariantStatuses()
      }

      handleElementEvent(event) {
        const target = event.target.previousElementSibling
        if (target?.tagName !== 'INPUT') return

        this.updateOptions(target)
        this.updateMasterId()
        this.currentVariant && this.getProductInfo()
      }

      async handleVariantChange() {
        if (this._isFixing) return

        this.updateOptions()
        this.updateMasterId()
        this.updateVariantStatuses()

        // If chosen combo is unavailable/null, snap to first available and re-run
        const changed = this.pickFirstAvailableIfNeeded()
        if (changed) {
          this.updateOptions()
          this.updateMasterId()
          this.updateVariantStatuses()
        }

        if (this.currentVariant) {
          this.updateURL()
          const html = await this.getProductInfo()

          publish(EVENTS.variantChange, {
            detail: {
              html,
              sectionId: this.sectionId,
              variant: this.currentVariant
            }
          })
        } else {
          publish(EVENTS.variantChange, {
            detail: {
              html: null,
              sectionId: this.sectionId,
              variant: null
            }
          })
        }
      }

      updateOptions(target) {
        this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
          if (element.tagName === 'SELECT') {
            return element.value
          }

          if (element.tagName === 'FIELDSET') {
            return Array.from(element.querySelectorAll('input')).find(
              (radio) => (target && radio === target) ?? radio.checked
            )?.value
          }
        })
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData().find(
          (variant) => !variant.options.map((option, index) => this.options[index] === option).includes(false)
        )
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
        return this.variantData
      }

      /**
       * If currentVariant doesn't exist or isn't available, set selects/radios
       * to the first available variant (prefer same option1/color if possible).
       * Returns true if it changed the UI values.
       */
      pickFirstAvailableIfNeeded() {
        const variants = this.getVariantData()
        if (!variants || !variants.length) return false

        // If we already have an available variant, no need to change
        if (this.currentVariant && this.currentVariant.available) return false

        const wrappers = [...this.querySelectorAll('select, fieldset')]
        if (!wrappers.length) return false

        const selectedOption1 = this.options?.[0]
        const firstAvailable =
          (selectedOption1 ? variants.find(v => v.available && v.option1 === selectedOption1) : null) ||
          variants.find(v => v.available)

        if (!firstAvailable) return false

        this._isFixing = true
        let changed = false

        wrappers.forEach((wrapper, index) => {
          const desiredValue = firstAvailable.options[index]
          if (!desiredValue) return

          if (wrapper.tagName === 'SELECT') {
            if (wrapper.value !== desiredValue) {
              wrapper.value = desiredValue
              changed = true
            }
          } else {
            const input = wrapper.querySelector(`input[value="${CSS.escape(desiredValue)}"]`)
            if (input && !input.checked) {
              input.checked = true
              changed = true
            }
          }
        })

        this._isFixing = false
        return changed
      }

      /**
       * ✅ supports SELECT + FIELDSET
       * Disables/un-disables next option values based on current selection.
       */
      updateVariantStatuses() {
        const variants = this.getVariantData()
        const wrappers = [...this.querySelectorAll('select, fieldset')]
        if (!wrappers.length) return

        // selected values in the same order as wrappers
        this.updateOptions()
        const selected = this.options || []
        const option1 = selected[0]
        if (!option1) return

        // filter by option1 (usually Color)
        const variantsForOption1 = variants.filter(v => v.option1 === option1)

        wrappers.forEach((wrapper, index) => {
          if (index === 0) return

          const prevValue = selected[index - 1]
          if (!prevValue) return

          let els = []
          if (wrapper.tagName === 'SELECT') {
            els = [...wrapper.querySelectorAll('option')]
          } else {
            els = [...wrapper.querySelectorAll('input[type="radio"]')]
          }

          const allowed = variantsForOption1
            .filter(v => v.available && v[`option${index}`] === prevValue)
            .map(v => v[`option${index + 1}`])
            .filter(Boolean)

          const allowedUnique = [...new Set(allowed)]
          this.setInputAvailability(els, allowedUnique)
        })
      }

      /**
       * disables INPUT and OPTION + adds data-disabled for styling
       */
      setInputAvailability(elementList, availableValuesList) {
        elementList.forEach((el) => {
          const value = el.getAttribute('value')
          const isAvailable = availableValuesList.includes(value)

          if (el.tagName === 'OPTION') {
            el.disabled = !isAvailable
            if (!isAvailable) el.setAttribute('data-disabled', 'true')
            else el.removeAttribute('data-disabled')
          }

          if (el.tagName === 'INPUT') {
            el.disabled = !isAvailable
            if (!isAvailable) el.setAttribute('data-disabled', 'true')
            else el.removeAttribute('data-disabled')
          }
        })
      }

      updateURL() {
        if ($('body').hasClass('product') && !$(this).parent().hasClass('quick-buy-drawer-info')) {
          if (!this.currentVariant || !this.updateUrl) return
          window.history.replaceState({}, '', `${this.url}?variant=${this.currentVariant.id}`)
        } else {
          $('quick-buy-drawer .top-section .btn').attr('href', `${this.url}?variant=${this.currentVariant.id}`)
        }
      }

      getProductInfo() {
        const requestedVariantId = this.currentVariant.id

        if (this.productInfo.has(requestedVariantId)) {
          return this.productInfo.get(requestedVariantId)
        }

        this.productInfo.set(
          requestedVariantId,
          fetch(`${this.url}?variant=${requestedVariantId}&section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((responseText) => new DOMParser().parseFromString(responseText, 'text/html'))
        )

        return this.productInfo.get(requestedVariantId)
      }

      get sectionId() {
        return this.getAttribute('section-id')
      }

      get updateUrl() {
        return this.getAttribute('update-url') === 'true'
      }

      get url() {
        return this.getAttribute('url')
      }
    }
    customElements.define('block-variant-picker', BlockVariantPicker)
    
    //VARIANT SKU JS
    class VariantSku extends HTMLElement {
      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(EVENTS.variantChange, this.handleVariantChange.bind(this))
      }
    
      disconnectedCallback() {
        this.variantChangeUnsubscriber?.()
      }
    
      handleVariantChange({ detail }) {
        const { html, sectionId, variant } = detail
    
        if (!variant) {
          this.textContent = ''
          return
        }
    
        const skuSource = html.querySelector(`[data-section-id="${sectionId}"] variant-sku`)
    
        if (skuSource) {
          this.textContent = skuSource.textContent
        }
      }
    }
    customElements.define('variant-sku', VariantSku)

    //PRICE JS
    class BlockPrice extends HTMLElement {
      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(EVENTS.variantChange, this.handleVariantChange.bind(this))
      }
    
      disconnectedCallback() {
        this.variantChangeUnsubscriber()
      }
    
      handleVariantChange({ detail }) {
        const { html, variant } = detail
    
        if (!variant) {
          this.querySelector('[data-price-container]').innerHTML = '&nbsp;'
          return
        }
    
        const priceSource = html.querySelector(
          `block-price[data-section-id="${this.dataset.sectionId}"] [data-price-container]`
        )
        const priceDestination = this.querySelector('[data-price-container]')
    
        if (priceSource && priceDestination) {
          priceDestination.outerHTML = priceSource.outerHTML
        }
      }
    }
    customElements.define('block-price', BlockPrice)

    //STOCK NOTICE JS
    class BlockStockNotice extends HTMLElement {
      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(EVENTS.variantChange, this.handleVariantChange.bind(this))
      }
    
      disconnectedCallback() {
        this.variantChangeUnsubscriber()
      }
    
      handleVariantChange({ detail }) {
        const { html, variant } = detail
        console.log(html)
        if($('quick-buy-drawer').children().length > 0){
          $('.quick-buy-drawer .notice-shipping-info').html(html.querySelector('.notice-shipping-info').innerHTML)
          
          if(html.querySelector('.notice-info').dataset.preorder == 'true'){
            $('.quick-buy-drawer .notice-info span').text('Pre-Order')
          } else if(html.querySelector('.notice-info').dataset.preorder == 'false' && html.querySelector('.notice-info').dataset.limitedstock == 'true'){
            $('.product-highlight .notice-info span').text('Limited stock')
          } else if(variant.available == false){
            $('.quick-buy-drawer .notice-info span').text('Sold-out')
          } else{
            $('.quick-buy-drawer .notice-info span').text('In-Stock')
          }
        } else{
          $('.product-highlight .notice-shipping-info').html(html.querySelector('.notice-shipping-info').innerHTML)

          $('.floating-add-to-cart').html(html.querySelector('.block-buy-buttons__submit').innerHTML)
          
          if(html.querySelector('.notice-info').dataset.preorder == 'true'){
            $('.product-highlight .notice-info span').text('Pre-Order')
            $('.floating-add-to-cart').removeClass('disabled')
          } else if(html.querySelector('.notice-info').dataset.preorder == 'false' && html.querySelector('.notice-info').dataset.limitedstock == 'true'){
            $('.product-highlight .notice-info span').text('Limited stock')
          } else if(variant.available == false){
            $('.product-highlight .notice-info span').text('Sold-out')
            $('.floating-add-to-cart').addClass('disabled')
          } else{
            $('.product-highlight .notice-info span').text('In-Stock')
            $('.floating-add-to-cart').removeClass('disabled')
          }
        }
      }
    }
    customElements.define('block-stock-notice', BlockStockNotice)

    //MAIN GALLERY SELECTED IMAGE JS
    class MainGalleryImageChange extends HTMLElement {
      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(EVENTS.variantChange, this.handleVariantChange.bind(this))
      }
    
      disconnectedCallback() {
        this.variantChangeUnsubscriber()
      }
    
      handleVariantChange({ detail }) {
        const { html, variant } = detail
        
        if($('quick-buy-drawer').children().length > 0){
          $('.quick-buy-drawer .color-indicator').removeClass('active');
          $('.quick-buy-drawer .color-indicator[data-title="'+ variant.option1 +'"]').addClass('active');
  
          $('.quick-buy-drawer main-image-gallery .featured_image').attr('src', variant.featured_image.src)
        } else{
          $('.product-highlight .color-indicator').removeClass('active');
          $('.product-highlight .color-indicator[data-title="'+ variant.option1 +'"]').addClass('active');
  
          $('.product-highlight main-image-gallery .featured_image').attr('src', variant.featured_image.src)
          $('.product-highlight main-image-gallery a').attr('href', variant.featured_image.src)
          
        }
      }
    }
    customElements.define('main-image-gallery', MainGalleryImageChange)

    

    //BUY BUTTON JS
    class BlockBuyButtons extends HTMLElement {
      connectedCallback() {
        this.addEventListener('submit', this.handleSubmit.bind(this))
    
        this.variantChangeUnsubscriber = subscribe(EVENTS.variantChange, this.handleVariantChange.bind(this))
        this.cartChangeUnsubscriber = subscribe(EVENTS.cartChange, this.handleCartChange.bind(this))
      }
    
      disconnectedCallback() {
        this.variantChangeUnsubscriber()
      }
    
      handleVariantChange({ detail }) {
        const { html, variant } = detail
    
        if (!variant) {
          this.toggleAddButton(true, this.getLocales().unavailable, html)
          return
        }
    
        this.updateVariantInput(variant)
        this.renderProductInfo(html)
      }
    
      handleCartChange() {
        window.location.href = `${window.Shopify.routes.root}cart`
      }
    
      renderProductInfo(html) {
        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`)
    
        if (addButtonUpdated) {
          this.toggleAddButton(addButtonUpdated.hasAttribute('disabled'), this.getLocales().soldOut, html)
        }
      }
    
      getLocales() {
        this.locales = this.locales || JSON.parse(this.querySelector('[type="application/json"]').textContent)
        return this.locales
      }
    
      toggleAddButton(disable = true, text, html) {
        const productForm = document.getElementById(`product-form-${this.dataset.sectionId}`)
    
        if (!productForm) return
    
        const addButton = productForm.querySelector('[name="add"]')
        const addButtonText = productForm.querySelector('[name="add"] > span')
    
        if (!addButton) return
    
        if (disable) {
          addButton.setAttribute('disabled', 'disabled')
          if (text) addButtonText.textContent = text
        } else {
          addButton.removeAttribute('disabled')
          addButtonText.textContent = html.querySelector('.block-buy-buttons__submit').textContent
          // addButtonText.textContent = this.getLocales().addToCart
        }
      }
    
      updateVariantInput(variant) {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.sectionId}, #product-form-installment-${this.dataset.sectionId}`
        )
    
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]')
          input.value = variant.id
    
          input.dispatchEvent(new Event('change', { bubbles: true }))
        })
      }
    
      async handleSubmit(event) {
        event.preventDefault()
        this.disableAddToCartButton()
    
        try {
          const responseJson = await this.addVariantToCart()
          const cart = await this.fetchCart()
    
          publish(EVENTS.cartChange, {
            detail: {
              cart,
              items: 'items' in responseJson ? responseJson['items'] : [responseJson]
            }
          })
        } catch (error) {
          console.error(`Error adding to cart: ${error}`)
        } finally {
          this.enableAddToCartButton()
        }
      }
    
      async addVariantToCart() {
        const formData = this.getFormDataWithSections()
    
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
    
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`)
        }
    
        return response.json()
      }
    
      async fetchCart() {
        return (await fetch(`${window.Shopify.routes.root}cart.js`)).json()
      }
    
      getFormDataWithSections() {
        const productForm = this.querySelector(`#product-form-${this.dataset.sectionId}`)
        const formData = new FormData(productForm)
    
        formData.set('sections_url', `${window.Shopify.routes.root}variants/${productForm.id.value}`)
    
        return formData
      }
    
      enableAddToCartButton() {
        const productForm = document.getElementById(`product-form-${this.dataset.sectionId}`)
    
        if (!productForm) return
    
        const addButton = productForm.querySelector('[name="add"]')
        addButton.removeAttribute('disabled')
        addButton.removeAttribute('aria-busy')
      }
    
      disableAddToCartButton() {
        const productForm = document.getElementById(`product-form-${this.dataset.sectionId}`)
    
        if (!productForm) return
    
        const addButton = productForm.querySelector('[name="add"]')
        addButton.setAttribute('disabled', '')
        addButton.setAttribute('aria-busy', 'true')
      }
    }
    customElements.define('block-buy-buttons', BlockBuyButtons)

    class ProductMediaGallery extends HTMLElement {
      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(EVENTS.variantChange, this.handleVariantChange.bind(this))
      }
    
      disconnectedCallback() {
        this.variantChangeUnsubscriber()
      }
    
      handleVariantChange({ detail }) {
        const { sectionId, variant } = detail
    
        if (!variant || !variant.featured_media) {
          return
        }
    
        const mediaContainer = this.querySelector(`[data-section-id="${sectionId}"][data-media-id="${variant.featured_media.id}"]`)
    
        if (!mediaContainer) {
          return
        }
    
        // const isMobile = window.matchMedia('screen and (max-width: 768px)').matches
        // const scrollOptions = isMobile
        //   ? { left: mediaContainer.offsetLeft - (this.offsetWidth - mediaContainer.offsetWidth) / 2, behavior: 'smooth' }
        //   : { top: mediaContainer.offsetTop, behavior: 'smooth' }
          
        // isMobile ? this.scrollTo(scrollOptions) : window.scroll(scrollOptions)
      }
    }
    
    customElements.define('product-media-gallery', ProductMediaGallery)

    //QUICK BUY FUNCTION
    async function quickBuyTrigger(currentClicked) {
      if (!this._hasLoaded) {
        const responseContent = 
        fetch(`${Shopify.routes.root}products/${currentClicked.getAttribute("handle")}`)
        .then(response => response.text())
        .then(data => new DOMParser().parseFromString(data, "text/html").getElementById("quick-buy-content").content)
        .then(final => $('quick-buy-drawer').html(final).css('display', 'flex'))
      } 
    }

    $('.quick-buy-button').on('click', function(e){
      e.preventDefault();
      quickBuyTrigger(this);
    })

    $('.angi-upsell .angi-upsell-content .info').on('click', function(e){
      $('.angi-upsell-modal-custom').fadeIn();
    })

    $('.angi-upsell-modal .angi-upsell-modal-close').on('click', function(e){
      $('.angi-upsell-modal-custom').fadeOut();
    })    

    $(document).on('click', '.close-quick-buy, .close-quick-buy-mobile', function(){
      $('quick-buy-drawer').empty()
      $('quick-buy-drawer').fadeOut();
    })
    
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // We listen to the resize event
    window.addEventListener('resize', () => {
        // We execute the same script as before
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    if($(document).width() > 1024){
      $(document).on("scroll", onScroll);
    }
    
    //smoothscroll
    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        $(document).off("scroll");
        
        $('a').each(function () {
            $(this).removeClass('active');
        })
        $(this).addClass('active');
      
        var target = this.hash,
            menu = target;
        $target = $(target);
        $('html, body').stop().animate({
            'scrollTop': $target.offset().top+2
        }, 500, 'swing', function () {
            window.location.hash = target;
            $(document).on("scroll", onScroll);
        });
    });

    //global banner opener
    $(document).on('click', '.open-banner-popup', function(){
      $('.banner-popup-wrap').fadeIn().css('display', 'flex');
    })

    $('.banner-overlay').on('click', function (e) {
      $('.banner-popup-wrap').fadeOut();
    })

    
    
    function onScroll(event){
      var scrollPos = $(document).scrollTop();

      $('.product-header-nav a').each(function () {
          var currLink = $(this);
          var refElement = $(currLink.attr("href"));

          if (refElement.position().top - 120 <= scrollPos && refElement.position().top - 120 + refElement.height() > scrollPos) {
              $('.product-header-nav ul li a').removeClass("active");
              currLink.addClass("active");
          }
          else{
              currLink.removeClass("active");
          }
      });
    }

    //global header script
    $(window).on('load',function() {})

    //opening desktop submenu menu
    $('header nav .have-submenu').hover(
        function(e) {
          e.preventDefault();
          $('body').addClass('no-menu-scroll')
          $(this).find('.submenu').fadeIn(0.1);
          $(this).find('> a').addClass('active');
          $('.header-overlay').fadeIn(0.1);
          e.stopPropagation();
        }, function() {
          $('body').removeClass('no-menu-scroll')
          $('.submenu').fadeOut(0.1);
          $(this).find('> a').removeClass('active');
          $('.header-overlay').fadeOut(0.1);
        }
    );

    //swithc between categoroy and bike models
    $('.bike-models-header h3').hover(
          function(e) {
            e.preventDefault();
            e.stopPropagation();
            $('.bike-models-header h3').removeClass('active');
            $(this).addClass('active');

            if($(this).data('menu') == 'left'){
              $('.menu-items').css('display', 'none')
              $('.bike-items').css('display', 'block')
            } else if($(this).data('menu') == 'right'){
              $('.menu-items').css('display', 'none')
              $('.category-items').css('display', 'block')
            }
          }
    );

    // $( ".primary-menu ul li, footer .bottom-content-wrap ul li" ).each(function( index ) {
    //     if(window.location.href == window.location.origin + $(this).find('a').first().attr('href')){
    //       $(this).find('a').first().addClass('current-page')
    //     }
    // });

    $('.menu-opener').on('click', function(){
        $(this).toggleClass('open');
        $('header').removeClass('transparent-header')
        $('.submenu').removeClass('active');
        $('body').toggleClass('no-menu-scroll')
        $('.mobile-menu').toggleClass('active')
        $('.header-overlay').fadeToggle(50);
        $('.announcment-bar').slideToggle();
    })

    $('.mobile-menu .have-submenu').on('click', function(){
        $('.submenu').removeClass('active');
        $(this).find('.submenu').addClass('active');
    })

    //prevent click on menu that has submenu for mobile
    $('.mobile-menu .first-link').on('click', function(e){
        e.preventDefault();
    })

    $('.submenu-header').on('click', function(e){
        e.stopPropagation();
        $('.submenu').removeClass('active');
    })

    $('.mobile-menu .menu-items-grid .single-menu h3').on('click', function(){
      $(this).toggleClass('active');
      $(this).parent().find('ul').slideToggle('fast').css('display', 'grid');
    })

    //FEEDBACK FORM LOGIC
    // $(document).ready(function() {
    //   if (window.location.href.indexOf("contact_posted=true#contact-feedback-form") > -1) {
    //     console.log('true')
    //     $('.feedback-form-holder').fadeIn().css('display', 'flex');
    //   } else{
    //     console.log('kita')
    //   }
    // });

    $('.leave-a-feedback-box').on('click', function(){
      $('.feedback-form-holder').fadeIn().css('display', 'flex');
    })

    $('.close-feedback-form, .close-feedback-form-button').on('click', function(){
      $('.feedback-form-holder').fadeOut();
      window.location.replace(window.location.pathname)
    })

  }


  return Object.freeze({
    init,
  })
}
